import React from 'react';

import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import connectAuth, { IAuthMapStateToProps, IConnectedProps, IConnectedPropsNull } from '../../hooks/connectAuth';

import Help from '../../../../presentational/Auth/Help';
import ProviderAuthGroup from '../../../Auth/ProviderGroup/ProviderAuthGroup';
import AuthProvider from '../../../Auth/ProviderGroup/Store/AuthContext';
import Button from '../../../Common/Form/Button';
import Separator from '../../../Common/Separator';
import { Types } from '../../Store/LoginReducer';
import { IAuthState } from '../../Store/Reducers';
import InputEmail from '../SignUp/PersonalData/InputEmail';
import InputPassword from '../SignUp/PersonalData/InputPassword/InputPassword';
import ForgotPassword from './ForgotPassword';
import LoginButton from './LoginButton';

const Container = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: ${({ theme }) => theme.space.cat};

    > ${Separator} {
        margin: 0;
    }

    #auth-login-button {
        min-width: 184px;
    }

    #auth-forgot-password-button {
        padding: 0;
    }

    .provider-auth__group {
        margin: 0;
        max-width: 280px;
        gap: ${({ theme }) => theme.space.cat};
        
        &--wide {
            max-width: 100%;
        }

        > a {
            margin: 0;
        }

        &[data-loading] {
            justify-content: center;
        }
    }

    .apple-auth__button,
    .google-auth__button,
    .facebook-auth__button {
        justify-content: start;
        gap: ${({ theme }) => theme.space.mouse};
        border-radius: ${({ theme }) => theme.radii.round};
        border: solid 1px ${({ theme }) => theme.colors.gray600};
        padding: ${({ theme }) => `${theme.space.bee} ${theme.space.cat}`};

        &[data-loading="true"] {
            justify-content: center;
        }

        &::before {
            width: 18px;
            height: 18px;
        }

        > span {
            margin: 0;
            font-size: ${({ theme }) => theme.fontSizes.mouse};
            font-weight: ${({ theme }) => theme.fontWeights.normal};
        }
    }
`;

const Login: React.FC<IConnectedProps<{ allowBottomTermsWarning?: boolean }>> = ({ allowBottomTermsWarning, dispatch }) => {
    const handleClickForgotPassword = (showFacebookMessage?: boolean) => {
        dispatch({
            type: Types.FORGOT_PASSWORD,
            data: {
                open: true,
                showFacebookMessage
            }
        });
    };

    return (
        <Container>
            <InputEmail />

            <InputPassword isLogin />

            <ForgotPassword />

            <LoginButton />

            <Button
                variation="text"
                id="auth-forgot-password-button"
                onClick={() => handleClickForgotPassword(false)}
            >
                <FormattedMessage id="authFunctional.forgotPassword.label" />
            </Button>

            <Separator />

            <AuthProvider onClickFacebookButton={() => handleClickForgotPassword(true)}>
                <ProviderAuthGroup />
            </AuthProvider>

            {allowBottomTermsWarning && <Help classNames="signup__terms-and-policy-informative" />}
        </Container>
    );
};

const mapStateToProps: IAuthMapStateToProps<{ allowBottomTermsWarning?: boolean }> = (state, isComparison = false) => {
    if (isComparison) {
        return {
            allowBottomTermsWarning: state.allowBottomTermsWarning
        };
    }

    return {
        allowBottomTermsWarning: (state as IAuthState).Container.allowBottomTermsWarning
    };
};

export default connectAuth(mapStateToProps)(Login);
